import * as React from 'react';
import './ChoosePlanPage.css';
import PricingCard from '../components/PricingCard';
import { apiRequest } from '../api/client';

interface Plan {
  title: string;
  price: string;
  features: string[];
  highlight?: boolean;
}

const ChoosePlanPage: React.FC = () => {
  const [plans, setPlans] = React.useState<Plan[]>([]);
  const [selectedPlan, setSelectedPlan] = React.useState<string | null>(null);

  React.useEffect(() => {
    apiRequest<Plan[]>('/plans')
      .then(setPlans)
      .catch(console.error);
  }, []);

  const handleSelect = async (plan: string) => {
    if (plan === 'Enterprise') return;

    setSelectedPlan(plan);

    try {
        const res = await apiRequest<{ url: string }>('/create-checkout-session', {
          method: 'POST',
          body: JSON.stringify({ plan }),
        });
        window.location.href = res.url;
    } catch (err) {
      console.error('Plan selection failed', err);
    }
  };


  return (
    <div className="choose-plan-page">
      <h1>Select a Plan</h1>
      <p className="choose-subtext">Pick a plan to activate your account</p>
      <div className="pricing-grid">
        {plans.map((plan, idx) => (
          <div className="fade-in" style={{ animationDelay: `${0.2 + idx * 0.2}s` }} key={plan.title}>
            <PricingCard
              title={plan.title}
              price={plan.price}
              features={plan.features}
              highlight={plan.highlight}
              selected={selectedPlan === plan.title}
              disabled={plan.title === 'Enterprise'}
              onSelect={() => handleSelect(plan.title)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChoosePlanPage;
